"use strict";

module.exports = function (accumulator, order, product, component) {
  var addition = component.rounded_corners ? 'ADD CORNER ROUNDING' : '';

  if (accumulator.length && addition.length) {
    return "".concat(accumulator, "\n").concat(addition);
  }

  return "".concat(accumulator).concat(addition);
};